import { ReleaseFileboxRecordDto } from '../dtos/release-filebox-record.dto';

/**
 * Release filebox records request DTO
 */
export class ReleaseFileboxRecordsRequest {
	records!: ReleaseFileboxRecordDto[];
}
